import React, { Suspense } from "react";
import Home from "./Home";
import { Alert, Box, Snackbar } from "@mui/material";
import Header from "../components/header/Header";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Footer from "../components/footer/Footer";
import GoogleTag from "../components/tracking/GoogleTag";
import {
  getShowSnackbar,
  getSnackbarSeverity,
  getSnackbarText,
  setShowSnackbar,
} from "../store/reducers/snackbarSlice";
import PrivateSpace from "./PrivateSpace";
import VideoPodcast from "./VideoPodcast";
import Logout from "./Logout";
import Chat from "./Chat";
import ScrollToTop from "../components/misc/ScrollToTop";

const RoutesDefinitions = () => {
  const showSnackBar = useSelector(getShowSnackbar);
  const snackbarText = useSelector(getSnackbarText);
  const snackbarSeverity = useSelector(getSnackbarSeverity) || "success";

  const dispatch = useDispatch();
  const handleCloseSnackbar = () => {
    dispatch(setShowSnackbar(false));
  };

  return (
    <div style={{ position: "relative" }}>
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Box container sx={{ flexWrap: "nowrap" }}>
          <Suspense>
            {/* GoogleTag en haut pour capter tous les changements de page */}
            <GoogleTag />
            <Routes>
              <Route path="/" element={<PrivateSpace />} />
              <Route path="/logout" element={<Logout />} />
              <Route path="/public" element={<Home />} />
              <Route path="/video-podcast/:slug" element={<VideoPodcast />} />
              <Route path="/ia" element={<Chat />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </Suspense>
        </Box>
      </BrowserRouter>
      <Footer />
      <Snackbar
        open={showSnackBar}
        autoHideDuration={2000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbarSeverity}
          sx={{ width: "100%" }}
        >
          {snackbarText}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default RoutesDefinitions;
